export const assign_reviewers = {
  Edit_steps: "Modifier les étapes",
  New_group_name: "Nom du nouveau groupe",
  Previously_created_groups: "Groupes créés précédemment",
  Save_this_group: "Enregistrer ce groupe",
  Selected_Theme: "Thème sélectionné",
  Steps: "Étapes",
} as const;
